<template>
    <setting-layout :title="$t('pages.user.setting.creator.dream_goal.title')">
        <template v-if="showCelebrationGif">
            <div class="dream-goal-celebration">
                <img :src="require('@/assets/animations/stream-goal-completed.gif')" alt="Playing..." style="width: 100%; height: 100%;" />
            </div>
        </template>
        <v-container>
            <div class="mb-4">
                <p>{{ $t("pages.user.setting.creator.dream_goal.description_details") }}</p>              
            </div>
            <v-form ref="form" class="auth-form mt-8">
                <v-row class="align-center" v-if="!isDreamGoalActive">
                    <v-col cols="6">
                        <text-field
                            v-model="name"
                            :placeholder="$t('pages.user.setting.creator.dream_goal.placeholder.name')"
                            :error-messages="errors.name"
                            :rules="nameRules"
                            outlined
                        />
                    </v-col>
                    <v-col cols="6">
                        <text-field
                            v-model="price"
                            :placeholder="$t('pages.user.setting.creator.dream_goal.placeholder.price')"
                            :error-messages="errors.price"
                            :prepend="currency"
                            v-on:keyup.enter="save"
                            :rules="priceRules"
                            outlined
                        />
                    </v-col>
                </v-row>   
                <div class="d-flex mt-2 align-center" v-if="isDreamGoalActive">
                    <v-progress-linear class="me-2"
                        :value="progressGoal"
                        width="5"
                        :color="progressGoalColor"
                        height="30"
                        striped
                        rounded
                    >
                        <template v-slot:default>
                            <span class="dream-goal-name">{{ data.name }}</span>
                            <span class="dream-goal-price">{{ Number(data.collected_tips) }} / {{ Number(data.price) }} {{ currency }} </span>
                        </template>
                    </v-progress-linear>
                </div>         
                <v-row justify="center" class="mt-8">
                    <gradient-button block @click="save" :loading="$store.state.buttonsLoading.DreamGoalBtn">
                         {{ activeStopbutton }} 
                    </gradient-button>
                </v-row>
            </v-form>
        </v-container>
    </setting-layout>
</template>

<script>
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import TextField from "@/components/app/form/TextField";
import GradientButton from "@/components/app/button/GradientButton";
import { CURRENCY_SYMBOL } from "@/configs/constants";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "DreamGoal",
    data: () => ({
        data: {},
        errors: {},
        name: '',
        price: '',
        currency: CURRENCY_SYMBOL,
        nameRules: [
            (v) => !!v || 'name is required',
        ],
        priceRules: [
            (v) => !!v || 'price is required',
        ],
        progressGoalColor: '#ff9100',
        showCelebrationGif: false,
    }),
    computed: {
        isDreamGoalActive() {
            return this.data?.is_activated === 1;
        },
        progressGoal() {
            if (this.data) {
                return (this.data.collected_tips / this.data.price) * 100;
            }
        },
        activeStopbutton() {
            return this.data?.is_activated == 1 ? this.$t('pages.user.setting.creator.dream_goal.stop') : this.$t('pages.user.setting.creator.dream_goal.save');
        },
    },
    methods: {
        ...mapMutations(["showSnackBar"]),
        ...mapActions([
            'saveDreamGoal',
            'getDreamGoal',
        ]),
        validateForm(form) {
            for (const key in form) {
                if (form.hasOwnProperty(key)) {
                    const value = form[key]
                    if (value === null || value === undefined || value === '' || value === 0) {
                        return false
                    }
                }
            }
            return true
        },
        async save() {
            const isValid = this.validateForm({name: this.name, price: this.price});
            if (!isValid) {
                this.showSnackBar(this.$t('pages.user.setting.creator.dream_goal.error'));
                return
            }

            const newStatus = this.data.is_activated == 1 ? 0 : 1;
            await this.saveDreamGoal({
                model: {
                    name: this.name,
                    price: this.price,
                    is_activated: newStatus,
                }
            }).then((res) => {
                this.errors = {}
                this.data = res.data;
                this.showSnackBar(this.$t('pages.user.setting.creator.dream_goal.saved'))
            }).catch(err => {
                this.errors = err.response.data.errors;
            });
        },
    },
    mounted() {
        this.getDreamGoal()
            .then((res) => {
                this.data = res.data || {};
                this.name = res.data?.name;
                this.price = res.data?.price;

                if (res.data?.collected_tips >= res.data?.price) {
                    this.showCelebrationGif = true;
                    setTimeout(() => {
                        this.showCelebrationGif = false;
                    }, 5000);
                }
            })
    },
    components: {GradientButton, TextField, SettingLayout}
}
</script>

<style scoped>
.dream-goal-name {
    font-size: 0.9em;
    font-weight: bold;
}

.dream-goal-price {
    position: absolute;
    right: 10px;
    font-size: 0.9em;
    font-weight: bold;
}

.dream-goal-celebration {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    z-index: 99999;
}

</style>
